/** Statuts de disponibilité stock (StockStatus API). */
export const STOCK_STATUSES = [
  { id: 1, label: "EN STOCK", color: "#27AE60" },
  { id: 2, label: "SUR ARRIVAGE", color: "#F2C94C" },
  { id: 3, label: "SUR COMMANDE", color: "#2D9CDB" },
  { id: 4, label: "RUP. MOMENTANEE", color: "#F2994A" },
  { id: 5, label: "RUPTURE", color: "#EB5757" },
];

export const STOCK_STATUS_UNKNOWN = {
  id: null,
  label: "PAS D'INFO",
  color: "#9a9a9a",
};

/** SaleStatus = 3 → produit abandonné. */
export const SALE_STATUS_ABANDONED = 3;

export function getStockStatusMeta(stockStatus) {
  return (
    STOCK_STATUSES.find((status) => status.id === stockStatus) ||
    STOCK_STATUS_UNKNOWN
  );
}

export function isAbandonedProduct(product) {
  return product?.SaleStatus === SALE_STATUS_ABANDONED;
}
